var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderContent',{on:{"change":_vm.changeHandler}}),_c('div',{staticClass:"content"},[_c(_vm.componentId,{tag:"component"}),_c('FooterContent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }